import { useQuery } from 'react-query'
import { accountService } from 'services/account.service'
import { Verify3DSPaymentDetails } from 'models/account.interface'
import { APIHooksKeysEnum } from '../enums/APIHooksKeysEnum'

export const verify3DSPayment = async (details: Verify3DSPaymentDetails) => {
  const { data } = await accountService.verify3DSPayment(details)

  return data
}

export const useVerify3DSPayment = (details: Verify3DSPaymentDetails) => {
  return useQuery(
    APIHooksKeysEnum.VERIFY_3DS_PAYMENT,
    () => verify3DSPayment(details),
    {
      enabled: false,
    }
  )
}
